import { useMutation } from "@tanstack/react-query";
import { contractValidationsApi } from "../../../modules/contract-validations/api";
import {
  ValidateContractGainers,
  ValidateContractNumbers,
  ValidateContractSigner,
} from "../../../modules/contract-validations/types";

export const CONTRACT_VALIDATIONS_QUERY_KEYS = {
  validateContractNumbers: () => ["validateContractNumbers"],
  validateContractSigner: () => ["validateContractSigner"],
  validateContractGainers: () => ["validateContractGainers"],
};

export const useValidateContractNumbers = () => {
  return useMutation({
    mutationKey: CONTRACT_VALIDATIONS_QUERY_KEYS.validateContractNumbers(),
    meta: { globalSpinner: false },
    mutationFn: (payload: ValidateContractNumbers) => {
      return contractValidationsApi.validateContractNumbers(payload);
    },
  });
};

export const useValidateContractSigner = () => {
  return useMutation({
    mutationKey: CONTRACT_VALIDATIONS_QUERY_KEYS.validateContractSigner(),
    meta: { globalSpinner: false },
    mutationFn: (payload: ValidateContractSigner) => {
      return contractValidationsApi.validateContractSigner(payload);
    },
  });
};

export const useValidateContractGainers = () => {
  return useMutation({
    mutationKey: CONTRACT_VALIDATIONS_QUERY_KEYS.validateContractGainers(),
    meta: { globalSpinner: false },
    mutationFn: (payload: ValidateContractGainers) => {
      return contractValidationsApi.validateContractGainers(payload);
    },
  });
};
